<template>
  <v-container>
    <v-row>
      <v-col cols="12" md="12" sm="12">
        <!-- <h4>Mağaza Seçimi</h4> -->
      </v-col>
      <v-col cols="12" md="3" sm="3">
        <v-menu v-model="menu1" :close-on-content-click="false" max-width="290">
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="startDate.date"
              clearable
              label="Başlangıç tarihi"
              readonly
              v-on="on"
              style="margin-top: 28px;"
              @click:clear="clearStartDate"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="startDate.originDate"
            :max="new Date().toISOString().substr(0, 10)"
            @change="
              orderByDateChange(startDate.originDate, endDate.originDate)
            "
          ></v-date-picker>
        </v-menu>
      </v-col>
      <v-col cols="12" md="3" sm="3">
        <v-menu v-model="menu3" :close-on-content-click="false" max-width="290">
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="endDate.date"
              clearable
              label="Bitiş tarihi"
              readonly
              v-on="on"
              style="margin-top: 28px;"
              @click:clear="clearEndDate"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="endDate.originDate"
            :min="nowDate"
            :disabled="datePickerDisable"
            :max="new Date().toISOString().substr(0, 10)"
            @change="
              orderByDateChange(startDate.originDate, endDate.originDate)
            "
          ></v-date-picker>
        </v-menu>
      </v-col>
      <v-col cols="12" md="3" sm="3">
        <v-btn
          color="#4d48f9"
          style="
            text-transform: none !important;
            color: white;
            margin-top: 35px;
            margin-left: 4px;
          "
          @click="exportOrderReports()"
        >
          EXPORT
        </v-btn>
      </v-col>
      <v-col cols="12" md="4" sm="4">
        <h4>Sıralama</h4>
        <v-select
          v-model="orderPageData.orderBy"
          @change="orderByChanged"
          :items="orderFilter"
          item-text="name"
          item-value="value"
          label="Sırala"
          data-vv-name="select"
          required
        ></v-select>
      </v-col>
    </v-row>
    <v-card>
      <v-card-title>
        Siparişler
        <v-spacer></v-spacer>
        <v-text-field
          v-model="orderPageData.search"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
          @input="searchOrderReport"
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :loading="loading"
        :headers="isAdmin() ? adminHeaders : venueHeaders"
        :items="allOrderReports"
        style="white-space: nowrap;"
        :footer-props="{
          'items-per-page-options': [10, 25, 50, 100],
          disablePagination: true,
        }"
        :items-per-page="10"
        @update:page="getPageNumber"
        @update:items-per-page="getItemPerPage"
      >
        <template v-slot:item.orderDegree="{ item }">
          <!-- <v-icon small class="mr-2" @click="routeCompanyEdit(item)">mdi-pencil</v-icon> -->
          <span v-if="item.orderDegree != null">{{ item.orderDegree }}</span>
          <span
            v-if="item.orderDegree == null"
            style="color: black; font-size: 20px;"
          >
            -
          </span>
        </template>
        <template v-slot:item.orderType="{ item }">
          {{
            item.orderType == 'Remote'
              ? 'Uzaktan Sipariş'
              : item.orderType == 'Cashierfront'
              ? 'Hemen Al Siparişi'
              : '-'
          }}
        </template>
      </v-data-table>
      <div class="text-xs-center pt-2">
        <v-pagination
          v-model="orderPageData.pageNumber"
          :color="'#4d48f9'"
          :length="pagination.pagesLength"
          @input="setPageNumber"
          :total-visible="10"
        ></v-pagination>
      </div>
    </v-card>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'OrderReports',
  data: () => ({
    // search: "",
    orderPageData: {
      pageNumber: 1,
      pageSize: 10,
      orderBy: null,
      search: '',
      startDate: null,
      endDate: null,
    },
    nowDate: '',
    datePickerDisable: true,
    startDate: { date: null, originDate: null },
    endDate: { date: null, originDate: null },
    menu1: false,
    menu2: false,
    menu3: false,
    menu4: false,
    orderFilter: [
      {
        name: 'Yok',
        value: null,
      },
      {
        name: 'Tarihe Göre (Yeni - Eski)',
        value: 'EndDate',
      },
      {
        name: 'Tarihe Göre (Eski - Yeni)',
        value: 'FirstDate',
      },
      {
        name: 'Önce Hemen Al Siparişler',
        value: 'CashierFront',
      },
      {
        name: 'Önce Uzaktan Siparişler',
        value: 'Remote',
      },
    ],
    pagination: {
      totalItems: 20,
      pagesLength: 0,
    },
    adminHeaders: [
      { text: 'USER ID', value: 'userId', align: 'start', sortable: false },
      //{ text: "Telefon", value: "phone",sortable: false  },
      // { text: "İsim/Soyisim", value: "fullName",sortable: false  },
      { text: 'Sipariş No', value: 'orderId', sortable: false },
      { text: 'Sipariş Tipi', value: 'orderType', sortable: false },
      { text: 'Ürün Adı', value: 'productName', sortable: false },
      { text: 'Mağaza(Tabela) Adı', value: 'venueName', sortable: false },
      { text: 'Değerlendirme', value: 'orderDegree', sortable: false },
      { text: 'Sipariş Tarihi', value: 'orderDate', sortable: false },
      {
        text: 'Talep Edilen Teslim Tarihi',
        value: 'deliveredDate',
        sortable: false,
      },
      {
        text: 'QR Okutma Tarihi',
        value: 'deliveredAccessDate',
        sortable: false,
      },
    ],
    venueHeaders: [
      { text: 'Sipariş No', value: 'orderId', sortable: false },
      // { text: "Telefon", value: "phone",sortable: false  },
      // { text: "İsim/Soyisim", value: "fullName",sortable: false  },
      { text: 'Sipariş Tipi', value: 'orderType', sortable: false },
      { text: 'Ürün Adı', value: 'productName', sortable: false },
      { text: 'Mağaza(Tabela) Adı', value: 'venueName', sortable: false },
      // { text: "Değerlendirme", value: "orderDegree", sortable: false },
      { text: 'Sipariş Tarihi', value: 'orderDate', sortable: false },
      {
        text: 'Talep Edilen Teslim Tarihi',
        value: 'deliveredDate',
        sortable: false,
      },
      {
        text: 'QR Okutma Tarihi',
        value: 'deliveredAccessDate',
        sortable: false,
      },
    ],
  }),
  watch: {
    'startDate.originDate': function () {
      this.nowDate = this.startDate.originDate
      this.datePickerDisable = false
    },
    '$route.query.page'(val) {
      const pageNumber = val ? Number(val) : 1
      this.getPageNumber(pageNumber)
    },
  },
  mounted() {
    this.startDate.originDate = this.startDate.date
    this.startDate.date = this.formatDate(this.startDate.date)
    this.endDate.originDate = this.endDate.date
    this.endDate.date = this.formatDate(this.endDate.date)
  },
  computed: mapGetters(['allOrderReports', 'loading']),
  created() {
    const page = this.$route.query.page ? this.$route.query.page : 1
    this.orderPageData.pageNumber = Number(page)

    let roles = JSON.parse(localStorage.getItem('userRoles'))

    if (roles.length > 0) {
      if (roles.includes('PanelUser')) {
        this.venueHeaders.unshift({
          text: 'USER ID',
          value: 'userId',
          align: 'start',
          sortable: false,
        })
        this.orderFilter.push(
          {
            name: 'Değerlendirmeye göre (1 - 5)',
            value: 'NotLike',
          },
          {
            name: 'Değerlendirmeye göre (5 - 1)',
            value: 'Like',
          },
        )
      }
    }

    this.getOrderReports(this.orderPageData).then((response) => {
      this.pagination.totalItems = response.totalCount
      this.pagination.pagesLength = response.totalPages
    })
  },
  methods: {
    ...mapActions(['getOrderReports', 'getOrderExportReports']),
    //Data table item per page changed function
    getItemPerPage(val) {
      this.orderPageData.pageSize = val
      this.orderPageData.pageNumber = 1
      this.getOrderReports(this.orderPageData).then((res) => {
        this.pagination.pagesLength = res.totalPages
      })
    },
    searchOrderReport(val) {
      this.getOrderReports(this.orderPageData).then((response) => {
        this.pagination.totalItems = response.totalCount
        this.pagination.pagesLength = response.totalPages
      })
    },
    //Data table page number changed function
    getPageNumber(val) {
      this.orderPageData.pageNumber = val
      if (val !== 1) {
        this.$router.push({ query: { page: val } })
      }
      this.getOrderReports(this.orderPageData)
    },
    setPageNumber(val) {
      if (
        (!this.$route.query.page && val == 1) ||
        this.$route.query.page == val
      )
        return
      this.$router.push({ path: this.$route.fullPath, query: { page: val } })
    },
    exportOrderReports() {
      const startDate = this.startDate.originDate
      const endDate = this.endDate.originDate
      this.getOrderExportReports({
        startDate: startDate ? new Date(startDate) : null,
        endDate: endDate ? new Date(this.endDate.originDate) : null,
        search: this.orderPageData.search,
        orderBy: this.orderPageData.orderBy,
      })
    },
    orderByChanged(value) {
      this.orderPageData.orderBy = value
      this.getOrderReports(this.orderPageData).then((response) => {
        this.pagination.totalItems = response.totalCount
        this.pagination.pagesLength = response.totalPages
      })
    },
    isAdmin() {
      let userRoles = []
      userRoles = JSON.parse(localStorage.getItem('userRoles'))
      if (userRoles.find((t) => t == 'PanelUser')) {
        return true
      } else {
        return false
      }
    },
    orderByDateChange(startDate, endDate) {
      this.startDate.originDate = startDate
      this.endDate.originDate = endDate
      this.startDate.date = this.formatDate(startDate)
      this.endDate.date = this.formatDate(endDate)
      if (startDate !== null) {
        startDate = startDate.split(/[- :]/)
        this.orderPageData.startDate =
          startDate[2] + '-' + startDate[1] + '-' + startDate[0]
      }
      if (endDate !== null) {
        endDate = endDate.split(/[- :]/)
        this.orderPageData.endDate =
          endDate[2] + '-' + endDate[1] + '-' + endDate[0]
      }
      this.orderPageData.pageNumber = 1
      this.getOrderReports(this.orderPageData).then((response) => {
        this.pagination.totalItems = response.totalCount
        this.pagination.pagesLength = response.totalPages
      })
    },
    formatDate(date) {
      if (!date) return null
      const [year, month, day] = date.split('-')
      return `${day}-${month}-${year}`
    },
    clearStartDate() {
      this.startDate.originDate = null
      this.startDate.date = null
    },
    clearEndDate() {
      this.endDate.originDate = null
      this.endDate.date = null
    },
  },
}
</script>

<style>
.v-data-footer__icons-before {
  display: none;
}

.v-data-footer__icons-after {
  display: none;
}
</style>
